<template>
  <nav class="nav">
    <!-- >767 -->
    <div class="hidden-xs-only nav-container">
      <div
        class="nav-item"
        :class="nowActivatedRouteName === item.name ? 'activated' : ''"
        v-for="item in routerList"
        :key="item.name"
        @click="onRouterIn(item)"
      >
        <span v-if="item.mode === 'normal'"> {{ $t(item.name) }}</span>
        <span v-else>{{ $i18n.tObject(item.meta, "name") }}</span>
      </div>
    </div>
    <!-- <=767 -->
    <div class="hidden-sm-and-up nav-container">
      <!-- 當前激活路由名稱 -->
      <div class="nav-item_sm">
        <span>{{ nowActRouteShowName }} </span>
      </div>
      <!-- 展開按鈕 -->
      <div class="nav-expand" @click="onExpendClick">
        <span class="el-icon-s-unfold"></span>
      </div>
      <!-- 列表 -->
      <div class="nav-routeList" v-if="isShowDownRouteList">
        <div
          class="nav-routeList_item"
          :class="nowActivatedRouteName === item.name ? 'activated' : ''"
          v-for="item in routerList"
          :key="item.name"
          @click="onRouterIn(item)"
        >
          <span v-if="item.mode === 'normal'"> {{ $t(item.name) }}</span>
          <span v-else>{{ $i18n.tObject(item?.meta, "name") }}</span>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      baseRouterList: [
        {
          name: "Home",
          path: "/home",
          mode: "normal",
        },
        // {
        //   name: "ForumSign",
        //   path: "/forum-sign",
        //   mode: "normal",
        // },
        {
          name: "ActivityTime",
          path: "/activity-time",
          mode: "normal",
        },
        {
          name: "BoothMap",
          path: "/booth-map",
          mode: "normal",
        },
      ],
      routerList: [],
      // 控制當前下拉列表顯示
      isShowDownRouteList: false,
      //當前激活路由名称 默認
      nowActivatedRouteName: null,
      // 當前激活路由展示的名字
      nowActRouteShowName: null,
    };
  },
  props: {
    addRouterList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  // 監聽下路由
  watch: {
    $route: {
      handler: function (v) {
        if (this.routerList.some((item) => item.name === v.name)) {
          this.nowActivatedRouteName = v.name;
        }
        // 路由切換也要更改名稱
        this.setRouteActShowName(this.routerList);
      },
      deep: true,
    },
    // 監聽下傳過來的路由
    addRouterList: {
      handler: function (v) {
        this.routerList = [...this.baseRouterList];
        if (Array.isArray(v)) {
          this.routerList.splice(1, 0, ...v);
        }
        // 把act路由名稱 和名字 加上去
        this.setRouteActName(this.routerList);
        this.setRouteActShowName(this.routerList);
      },
      deep: true,
      immediate: true,
    },
    // 監聽下語言
    "$i18n.locale"() {
      // 語言切換也要更改名稱
      this.setRouteActShowName(this.routerList);
    },
  },
  async created() {},
  methods: {
    onRouterIn(item) {
      // 如果名称相同
      if (this.$route.fullPath === item.path) return false;
      this.nowActivatedRouteName = item.name;
      this.$router.push({
        path: item.path,
      });
      this.isShowDownRouteList = !this.isShowDownRouteList;
    },
    onExpendClick() {
      this.isShowDownRouteList = !this.isShowDownRouteList;
    },
    // 設置激活名稱 和名字
    setRouteActName(routeList) {
      // 先篩當前路由數組
      if (routeList.some((item) => item.name === this.$route.name)) {
        this.nowActivatedRouteName = this.$route.name;
        return;
      }
      // 上面找不到相同的， 取id取遍歷
      const { categoryId } = this.$route.query;
      const nowActRoute = this.$router
        .getRoutes()
        .filter((item) => item.meta.id && item.meta.id === categoryId);
      if (nowActRoute.length !== 0) {
        this.nowActivatedRouteName = nowActRoute[0].name;
        return;
      }
      // 最後出口情況 默認首頁
      this.nowActivatedRouteName = "Home";
    },
    // 設置激活展示的名字
    setRouteActShowName(routeList = []) {
      routeList.forEach((item) => {
        if (item.name === this.nowActivatedRouteName) {
          if (item.meta) {
            this.nowActRouteShowName = this.$i18n.tObject(item.meta, "name");
          } else {
            this.nowActRouteShowName = this.$t(item.name);
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: relative;
  background: linear-gradient(90deg, #7d4aa9, #3858e5);
  .nav-container {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .nav-item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 42px;
    flex: 0 1 auto;
    font-size: 1.15rem;
    font-weight: bold;
    color: #fff;
    transition: 0.3s ease;
    text-align: center;
    padding: 4px 15px;
    &:hover,
    &.activated {
      background: #3537a9;
      border-radius: 10px 10px 0 0;
    }
  }
  .nav-item_sm {
    padding: 8px 0;
    text-align: center;
    font-size: 1.15rem;
    font-weight: bold;
    color: #fff;
    width: 83%;
  }
  .nav-expand {
    cursor: pointer;
    background: #3537a9;
    position: absolute;
    top: 0;
    left: 0%;
    height: 100%;
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 28px;
    padding: 0 5px;
  }
  .nav-routeList {
    z-index: 99;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background-color: #c3c4c4;
    padding-bottom: 30px;
    &_item {
      font-size: 20px;
      line-height: 42px;
      color: #fff;
      font-weight: bold;
      text-align: center;
      border-bottom: 1px solid #c3c4c4;
      border-radius: 2px 2px 0 0;
      &.activated {
        background: #3537a9;
      }
    }
  }
}
</style>
